import React, { useEffect, useState, createContext } from 'react';
import ReactModal from 'react-modal';
import { combineClassNames } from '../../css';
import { useTheme } from '../Theme/ThemeProvider';
export const OnRequestCloseContext = createContext(() => {
    /* do nothing */
});
const Modal = ({ appElement, bodyOpenClassName, children, className, contentLabel, fullscreen = true, isOpen, onRequestClose = () => {
    /* do nothing */
}, overlayClassName, ref }) => {
    const theme = useTheme();
    const [styles, setStyles] = useState(null);
    useEffect(() => {
        import(`./styles/${theme}.scss`).then((styles) => {
            setStyles(styles);
        });
    }, []);
    const [isClosing, setIsClosing] = useState(false);
    useEffect(() => {
        if (isClosing) {
            setTimeout(() => {
                onRequestClose && onRequestClose();
                setIsClosing(false);
            }, 500);
        }
    }, [isClosing]);
    return (React.createElement(React.Fragment, null, styles && (React.createElement(React.Fragment, null,
        React.createElement(ReactModal, { appElement: appElement, bodyOpenClassName: combineClassNames('cv-modal__body--open', bodyOpenClassName), className: combineClassNames('cv-modal__reveal', fullscreen ? 'cv-modal__reveal--fullscreen' : '', isClosing ? 'cv-modal__close' : '', className), contentLabel: contentLabel, contentRef: ref, isOpen: isOpen, onRequestClose: () => setIsClosing(true), overlayClassName: combineClassNames('cv-modal__overlay', overlayClassName) },
            React.createElement(OnRequestCloseContext.Provider, { value: () => setIsClosing(true) },
                React.createElement("div", { className: "cv-modal" }, children)))))));
};
export default Modal;
//# sourceMappingURL=Modal.js.map